import { apiClient } from '../core/api/client';

export function trackClientEvent(event, props = {}, source = 'mini_app') {
  if (import.meta.env.MODE === 'test') return;

  void apiClient.analytics.track(event, props, source).catch((error) => {
    console.warn('[Analytics] Client event failed:', event, error?.message || error);
  });
}
